import { createCRUDHook } from './createCRUDHook';
import {
  CREATE_BULK_ENTITY,
  ECG_PART_AND_STORE_CATEGORY,
} from './apiEndPoints';

interface PartAndStoreCategoryCustomOperations {
  postPartAndStoreData: (param: any[]) => Promise<boolean>;
  deletePartsAndStoreCategoryData: (id: number) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  any,
  any,
  PartAndStoreCategoryCustomOperations
>({
  entityName: 'PartAndStoreCategory',
  endpoint: ECG_PART_AND_STORE_CATEGORY,

  customOperations: (auth) => ({
    postPartAndStoreData: async (param: any[]): Promise<boolean> => {
      try {
        let res = await auth.makeAuthenticatedPost(
          ECG_PART_AND_STORE_CATEGORY + CREATE_BULK_ENTITY,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    deletePartsAndStoreCategoryData: async (id: number): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedDelete(
          `${ECG_PART_AND_STORE_CATEGORY}/${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return false;
      }
    },
  }),
});

export const PartAndStoreCategoryContext = Context;
export const usePartAndStoreCategoryManager = useManager;
export const usePartAndStoreCategory = useConsumer;
